module.exports = __webpack_public_path__ + "static/media/diva68.394390a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diva/diva68.jpg
// module id = 614
// module chunks = 0